import FinTronConfig from '@fintronners/react-config/src/Config/FinTronConfig';

export default {
  profileSettings: {
    basicInformation: 'Informações básicas',
    address: 'Endereço',
    citizenshipStatus: 'Status de cidadania',
    investorInformation: 'Informações do investidor',
    riskProfile: 'Perfil de risco',
    saveSuccess: 'Suas alterações foram enviadas com sucesso.',
    saveError: `Não foi possível salvar suas alterações. Por favor, tente novamente mais tarde. Se o problema persistir, entre em contato com ${FinTronConfig.supportEmail}.`,
  },
  bankLink: {
    title: 'Contas bancárias vinculadas',
    description: `Altere ou atualize sua vinculação bancária usando o Plaid. Selecione uma conta bancária abaixo ou adicione uma nova conta para entrar no Plaid.\n\nGerencie suas contas bancárias vinculadas para ${FinTronConfig.robo.name} e ${FinTronConfig.selfDirected.name} usando o Plaid, uma ferramenta de verificação bancária de terceiros.`,
    account: 'Conta {{ account }}',
    discretionaryDescription: '',
  },
  profileUpdates: {
    title: 'Atualizar informações',
    description: 'Esta atualização será aplicada ao seu perfil.',
    yesUpdate: 'Sim, Atualizar',
  },
  security: {
    title: 'Segurança',
    password: 'Atualizar senha',
    twoFactorAuth: 'Autenticação de dois fatores',
    login: 'Login',
    loginDescription:
      'Enviaremos um e-mail ou SMS com o código de autenticação de dois fatores para cada login.',
  },
  investmentQuestions: {
    title: 'Questões de Investimento',
    notSure: 'Se não tiver certeza, provavelmente não se aplica.',
    experienceLevelQuestion: 'Qual é o seu nível de experiência com investimentos?',
    annualIncomeOptions: {
      _025000: 'Menor ou igual a $25,000',
      _2500150000: '$25,001-$50,000',
      _50001100000: '$50,001-$100,000',
      _100001200000: '$100,001-$200,000',
      _200001300000: '$200,001-$300,000',
      _300001500000: '$300,001-$500,000',
      _5000011000000: '$500,001-$1,000,000',
      _5000011200000: '$500,001-$1,200,000',
      _10000015000000: '$1,000,001-$5,000,000',
      _12000019999999: '$1,200,001-$9,999,999',
      _50000019999999: '$5,000,001-$9,999,999',
      Unspecified: 'Não especificado',
    },
    netWorthOptions: {
      _025000: 'Menor ou igual a $25,000',
      _050000: 'Menor ou igual a $50,000',
      _2500150000: '$25,001-$50,000',
      _50001100000: '$50,001-$100,000',
      _100001200000: '$100,001-$200,000',
      _200001300000: '$200,001-$300,000',
      _200001500000: '$200,001-$500,000',
      _300001500000: '$300,001-$500,000',
      _5000011000000: '$500,001-$1,000,000',
      _10000015000000: '$1,000,001-$5,000,000',
      _50000019999999: '$5,000,001-$9,999,999',
      Unspecified: 'Não especificado',
    },
    netWorthRangeInfoTitle: 'Encontrando seu Patrimônio Líquido',
  },
  investorInformation: {
    investing: 'Investimento',
    personal: 'Pessoais',
    compliance: 'Compliance',
    investmentExperience: 'Experiência com investimentos',
    investmentObjective: 'Objetivo de investimento',
    investmentTimeHorizon: 'Horizonte de investimento',
    importanceOfCashOnHand: 'Importância de ter dinheiro em mãos',
    marriageStatus: 'Estado civil',
    employmentStatus: 'Status de emprego',
    annualIncome: 'Renda anual',
    netWorth: 'Patrimônio líquido',
  },
};
